var _g, _path, _line, _line2, _line3, _line4, _path2, _path3, _path4, _path5, _path6, _path7, _line5, _line6, _circle, _line7, _path8, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithoutPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 111,
    viewBox: "0 0 121 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3907 85.4919H9.06765C4.8872 85.4919 1.5 82.1047 1.5 77.9243V9.72024C1.5 5.53979 4.8872 2.15259 9.06765 2.15259H77.3907C81.5711 2.15259 84.9583 5.53979 84.9583 9.72024V77.9322C84.9504 82.1048 81.5632 85.4919 77.3907 85.4919Z",
    fill: "#CAB7EB",
    stroke: "#CAB7EB",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.865 35.0506C65.865 31.0414 64.8126 27.1025 62.813 23.6275C60.8135 20.1526 57.9368 17.2633 54.4705 15.2487C51.0043 13.2341 47.07 12.1646 43.0608 12.1472C39.0517 12.1298 35.1082 13.165 31.6246 15.1495L35.5106 21.9712C37.8001 20.667 40.3918 19.9866 43.0267 19.998C45.6616 20.0094 48.2474 20.7123 50.5254 22.0364C52.8035 23.3604 54.6941 25.2593 56.0083 27.5431C57.3224 29.8269 58.0141 32.4157 58.0141 35.0506H65.865Z",
    fill: "#DDD0F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.8022,
    cy: 31.9843,
    r: 1.5,
    stroke: "#DDD0F2",
    strokeWidth: 1.73519
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.4314,
    cy: 38.6137,
    r: 1.5,
    stroke: "#DDD0F2",
    strokeWidth: 1.73519
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.9127,
    y1: 29.7303,
    x2: 39.4953,
    y2: 40.1478,
    stroke: "#DDD0F2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.6929,
    y1: 66.9453,
    x2: 68.7396,
    y2: 66.9453,
    stroke: "#DDD0F2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9576 67.0247L49.7988 67.0247",
    stroke: "#DDD0F2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9576 73.6541L49.7988 73.6541",
    stroke: "#DDD0F2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.6929,
    y1: 73.5745,
    x2: 68.7396,
    y2: 73.5745,
    stroke: "#DDD0F2",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.554 98.998H37.4103C32.9961 98.998 29.4194 95.4214 29.4194 91.0072V18.9889C29.4194 14.5747 32.9961 10.998 37.4103 10.998H109.554C113.968 10.998 117.545 14.5747 117.545 18.9889V91.0156C117.537 95.4214 113.96 98.998 109.554 98.998Z",
    fill: "white",
    stroke: "#525067",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 82.4194,
    y1: 57.4026,
    x2: 100.419,
    y2: 57.4026,
    stroke: "#6D46DD",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 82.4194,
    y1: 71.4026,
    x2: 100.419,
    y2: 71.4026,
    stroke: "#6D46DD",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 49.4194,
    y1: 57.4026,
    x2: 67.4194,
    y2: 57.4026,
    stroke: "#6D46DD",
    strokeWidth: 2.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 49.4194,
    y1: 71.4026,
    x2: 67.4194,
    y2: 71.4026,
    stroke: "#6D46DD",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4194 57.1526L47.4194 57.1526",
    stroke: "#CAB7EB",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4194 71.1526L47.4194 71.1526",
    stroke: "#CAB7EB",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4194 57.1526L80.4194 57.1526",
    stroke: "#CAB7EB",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4194 71.1526L80.4194 71.1526",
    stroke: "#CAB7EB",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4194 64.1526L47.4194 64.1526",
    stroke: "#CAB7EB",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4194 64.1526L80.4194 64.1526",
    stroke: "#CAB7EB",
    strokeWidth: 2.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 82.4194,
    y1: 64.4026,
    x2: 100.419,
    y2: 64.4026,
    stroke: "#6D46DD",
    strokeWidth: 2.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 49.4194,
    y1: 64.4026,
    x2: 67.4194,
    y2: 64.4026,
    stroke: "#6D46DD",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 94.3477,
    r: 16.5,
    fill: "#D7D9E0"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 110.801,
    y1: 95.1528,
    x2: 96.4997,
    y2: 95.1528,
    stroke: "#525067",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.65 101.848L103.65 87.8477",
    stroke: "#525067",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 38.1526,
    width: 17,
    height: 7,
    fill: "#6D46DD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 38.1526,
    width: 43,
    height: 7,
    fill: "#DDD0F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutPortfolio);
export default __webpack_public_path__ + "static/media/without-portfolio.fe96bbd3473c763c802ebacd9dddacb4.svg";
export { ForwardRef as ReactComponent };